<template>
  <div class="order-input border rounded p-2 mt-4">
    <p class="font-weight-normal font-italic p-0 m-0">Part Number:</p>
    <parts-input v-model="partNumber" placeholder="Part number.." />
    <p class="font-weight-normal font-italic p-0 m-0">Quantity:</p>
    <b-form-input size="sm" type="number" v-model="orderQuantity" placeholder="Qty.." />
    <b-button
      size="sm"
      type="submit"
      @click="submitPart"
      variant="primary"
      class="mt-3 w-100"
    >Add Part</b-button>
  </div>
</template>

<script>
import PartsInput from "./PartsInput";
export default {
  name: "order-input",
  components: { PartsInput },
  data() {
    return {
      partNumber: "",
      orderQuantity: 1
    };
  },
  methods: {
    submitPart(evt) {
      evt.preventDefault();
      this.$store.dispatch("order/addItem", {
        partNumber: this.partNumber,
        orderQuantity: this.orderQuantity || 1
      });
      this.partNumber = "";
      this.orderQuantity = 1;
    }
  }
};
</script>


<style lang="scss" scoped>
</style>
